import type {Recipe} from './types';

export const tagliataConRucolaEPomodorini: Recipe = {
    id: 20,
    key: "tagliataConRucolaEPomodorini",
    pictures: [
        {index: 0, url: "https://www.giallozafferano.it/images/ricette/215/21544/foto_hd/hd650x433_wm.jpg"},
    ],
    video: "https://youtu.be/II0Bxv6I6r0?si=7oHHyuL5z0ur7qa-",
    i18n: {
        IT: {
            title: "Tagliata con Rucola e Pomodorini",
            servings: "Porzioni per 2 persone",
            ingredients: [
                "Entrecote (meglio se frollata perché più morbida)",
                "Sale",
                "Pepe",
                "Olio d'oliva",
                "Rucola",
                "Pomodorini piccoli",
            ],
            steps: [
                "Scaldare la piastra antiaderente a fuoco alto.",
                "Quando è bella calda, mettere la carne. Cuocere 3 minuti a fuoco medio da un lato e 3 dall'altro.",
                "Controllare la temperatura con un termometro per alimenti. Togliere quando la temperatura raggiunge i 52-54 gradi.",
                "Mettere la carne su un piatto e lasciare riposare qualche minuto.",
                "Preparare in un piatto separato la rucola.",
                "Tagliare la carne a strisce e posizionarla sulla rucola.",
                "Aggiungere i pomodorini tagliati a metà.",
                "Condire con sale grosso, pepe e olio d'oliva.",
            ],
            notes: "Non tagliare la carne mentre cuoce perché perde il liquido e diventa dura. Tenere la carne più al sangue possibile per preservare la morbidezza. Lasciare riposare la carne è importante per mantenerla morbida.",
        },
        EN: {
            title: "Sliced Steak with Arugula and Cherry Tomatoes",
            servings: "Serves 2",
            ingredients: [
                "Entrecote (preferably aged for tenderness)",
                "Salt",
                "Pepper",
                "Olive oil",
                "Arugula",
                "Cherry tomatoes",
            ],
            steps: [
                "Heat a non-stick griddle over high heat.",
                "When it is hot, place the meat on it. Cook for 3 minutes over medium heat on one side and 3 minutes on the other.",
                "Check the temperature with a food thermometer. Remove when the temperature reaches 52-54 degrees Celsius.",
                "Place the meat on a plate and let it rest for a few minutes.",
                "Prepare the arugula on a separate plate.",
                "Cut the meat into strips and place it on the arugula.",
                "Add the cherry tomatoes, halved.",
                "Season with coarse salt, pepper, and olive oil.",
            ],
            notes: "Do not cut the meat while it cooks because it loses its juices and becomes tough. Keep the meat as rare as possible to preserve tenderness. Letting the meat rest is important to keep it tender.",
        },
        PL: {
            title: "Stek z Rukolą i Pomidorkami",
            servings: "Porcje dla 2 osób",
            ingredients: [
                "Antrykot (najlepiej dojrzewający, aby był bardziej delikatny)",
                "Sól",
                "Pieprz",
                "Oliwa z oliwek",
                "Rukola",
                "Pomidorki koktajlowe",
            ],
            steps: [
                "Rozgrzej nieprzywierającą patelnię na dużym ogniu.",
                "Gdy będzie gorąca, połóż na niej mięso. Smaż przez 3 minuty na średnim ogniu z jednej strony i 3 minuty z drugiej strony.",
                "Sprawdź temperaturę za pomocą termometru do żywności. Zdejmij, gdy temperatura osiągnie 52-54 stopnie Celsjusza.",
                "Połóż mięso na talerzu i pozostaw na kilka minut, aby odpoczęło.",
                "Przygotuj rukolę na osobnym talerzu.",
                "Pokrój mięso na paski i połóż na rukoli.",
                "Dodaj przepołowione pomidorki koktajlowe.",
                "Dopraw grubą solą, pieprzem i oliwą z oliwek.",
            ],
            notes: "Nie kroj mięsa podczas gotowania, ponieważ traci soki i staje się twarde. Trzymaj mięso jak najrzadsze, aby zachować jego delikatność. Odpoczynek mięsa jest ważny, aby pozostało miękkie.",
        },
    },
};
